export default {
      Manufacturers: 'الشركة المصنعة|الشركات المصنعة',
      Manufacturers_no_body: 'شركة مصنعة',

};
